/* eslint-disable no-unused-vars*/
import React, { useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCookie } from 'helper/cookie';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Row, Col, Form } from 'antd';
import { get } from 'lodash';
import TableCategory from './table';
import SearchCategory from './search.categoryTutorial';
import { getCategoryTutorialAll } from 'api/categoryTutorial';
const initialState = {
  data: [],
  isLoading: true,
  isLoadingCategory: true,
  pagination: {
    total: 0,
    showSizeChanger: false,
    defaultPageSize: 10,
    current: 1,
    limit: 10,
    offset: 0,
    search: '',
  },
  search: {
    order_by: '',
    order_type: '',
  },
};

const CategoryTutorialComponents = () => {
  const isMobileView = useSelector(state => get(state, 'device.isMobileView', false));
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [paginate, setPaginate] = useState<any>(initialState.pagination);
  const token = getCookie('access_tokenltl');
  const [form] = Form.useForm();

  const fetchCategoryList = useCallback(
    async (query?: any) => {
      setIsLoading(true);
      const params = {
        limit: query?.limit ? query?.limit : paginate.limit,
        offset: query?.offset ? query?.offset : paginate.offset,
        order_by: 'id',
        order_type: 'DESC',
        total: query?.total ? query?.total : paginate.total,
        search: query?.search ? query?.search : null,
      };
      try {
        const responseData = await getCategoryTutorialAll({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setData(data?.data?.category_tutorial);
          setPaginate((prevState: any) => {
            return {
              ...prevState,
              total: data?.data?.total,
              last_page: data?.data?.total / prevState.limit,
              current: prevState.current,
            };
          });
          setIsLoading(false);
        } else {
          setData([]);
          setPaginate(initialState.pagination);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    [paginate.limit, token],
  );

  useMemo(() => {
    if (token) {
      fetchCategoryList();
    }
  }, [token, fetchCategoryList]);

  const onChangePage = (e: any) => {
    const { current } = e;
    const data = form.getFieldsValue();
    const query = {
      // ...search,
      limit: paginate.limit,
      offset: paginate.limit * (current - 1),
      total: paginate.total,
      search: data?.search,
      current: current,
      showSizeChanger: false,
    };
    setPaginate(query);
    fetchCategoryList(query);
  };

  const handleSubmit = (values: any) => {
    const search = values?.search;
    const query = {
      search: search,
    };
    fetchCategoryList(query);
  };

  const handleReset = () => {
    form.resetFields();
    setPaginate(initialState.pagination);
    fetchCategoryList();
  };

  return (
    <Form autoComplete="off" onFinish={handleSubmit} form={form} initialValues={{ search: '' }}>
      <Row justify="end" gutter={16}>
        <Col>
          <Button
            type="primary"
            className="btn-add btn-border-8"
            onClick={() => navigate('/backoffice/category_tutorial/create', { replace: true })}
            size="large"
          >
            <PlusOutlined /> เพิ่มข้อมูลหมวดหมู่วีดีโอ
          </Button>
        </Col>
      </Row>
      <div className="mt-4" />
      <Row justify="end" gutter={16} style={{ marginLeft: '7px' }}>
        <Col span={24}>
          <SearchCategory form={form} handleSubmit={handleSubmit} handleReset={handleReset} />
        </Col>
      </Row>

      <div className="mt-3 mb-3" />
      <TableCategory
        isLoading={isLoading}
        data={data}
        renderData={fetchCategoryList}
        pagination={paginate}
        onChangePage={onChangePage}
        navigate={navigate}
        token={token}
      />
    </Form>
  );
};

export default CategoryTutorialComponents;
